import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractAuditDto, MaskingDto, MaskingTypeEnum } from '../../service/dto';
import { HttpMaskingService } from '../../service/http-masking.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { map, Observable } from 'rxjs';
import { HttpAuditService } from '../../service/http-audit.service';

@Component({
  selector: 'app-masking',
  standalone: false,
  templateUrl: './masking.component.html',
  styleUrl: './masking.component.scss'
})
export class MaskingComponent implements OnInit, OnDestroy{
	simProperties: MaskingDto[] = [];
	personalDataProperties: MaskingDto[] = [];
	agentDataProperties: MaskingDto[] = [];
	allProperties: MaskingDto[] = [];
	selectedTabIndex = 0;
	modifications!: Observable<AbstractAuditDto[]>;

	constructor(
		private maskingService: HttpMaskingService,
		private auditService: HttpAuditService,
		private messageService: NzMessageService){}

	ngOnInit(): void {
		this.maskingService.get().subscribe(result => this.populate(result));

		this.modifications = this.auditService.getModificationsToMasking(0,1000).pipe(
			map(item => item.records as AbstractAuditDto[])
		);
	}
	ngOnDestroy(): void {

	}
	private populate(input: MaskingDto[]){
			this.allProperties=input;
			this.simProperties = input.filter(item => item.maskingGroup == 'SimCard');
			this.personalDataProperties = input.filter(item => item.maskingGroup == 'PersonalData');
			this.agentDataProperties = input.filter(item => item.maskingGroup == 'AgentData');
		}
	doSubmit(){
		this.maskingService.save(this.allProperties).subscribe(result => {
			this.populate(result);
			this.messageService.info("Masking Saved");
		});
	}
	trackByHashCode(index: number, item: MaskingDto): number {
		return item.hashCode;
	}
}
